import React, { useEffect, useState } from "react";
import { Table, Card, message, LockOutlined, Select, Switch, useDispatch, useSelector, Input, Button, Form, Drawer, Checkbox,Popconfirm, Radio, EditFilled, SearchOutlined, UserAddOutlined, Tooltip,EyeOutlined } from '../../AntComponent';
import { addUser, assocOtherProducts, changePass, changeUserStatus, searchUserActGrid, subscribedProduct, userActGrid } from "../../../store/actions/security/UserAccountMgmtAction";
import { userTypeRoleDpdn } from "../../../store/actions/security/serviceRefAction";
import UserDetail from "./sub-tabs/UserDetail";
import { getUserType } from "../../../store/actions/security/userRoleAction";


export default function UserAccManagement() {
  const [form, form1] = Form.useForm();

  // const [form1] = Form.useForm();
  const { userTblData, userTblData1, success6,success7, associatedProdInfo,success4, loading, success5, subsProductInfo } = useSelector(state => state.userAccMgmt);
  const {assProdData}=useSelector(state=>state.userRole);
  const { profileInfo } = useSelector(state => state.userPrf);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const appUserID = profileInfo?.data?.appUser?.appuserID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPage = userTblData ? userTblData?.data?.serverSearchables?.recordsTotal : 0;
  const [searchTableVal, setSearchTableVal] = useState("");
  const [sortField, setSortField] = useState("AppUserID");
  const [sortOrder, setSortOrder] = useState("Desc");

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { typeRoleDpd } = useSelector(state => state.serviceRef);
  const [checkedVal, setCheckedVal] = useState("1");
  const [showDetail, setShowDetail] = useState(false);
  const [tableData,setTableData] = useState([]);
  const [appUserId, setAppUserId] = useState(0);
  // const tableData = userTblData ? userTblData?.data.appUserLists : [];
  const [searchData, setSearchData] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [groupStatus, setGroupStatus] = useState(false);
  const [userStatus, setUserStatus] = useState("Active");
  const [openPass, setOpenPass] = useState(false);
  const [productsInfo, setProductsInfo] = useState([]);

  const [showSuccessmsg, setShowsuccessmsg] = useState(false);
  const successmsg = showSuccessmsg ? success6 : null;
  const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
  const successmsg1 = showSuccessmsg1 ? success5 : null;
  const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
  const successmsg2 = showSuccessmsg2 ? success7 : null;
  const [showSuccessmsg3, setShowsuccessmsg3] = useState(false);
  const successmsg3 = showSuccessmsg3 ? success6 : null;
  const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const [assProductFlag, setAssProductFlag] = useState(false);

  const showDrawer = () => {
    setOpen(true);
    setSearchData([]); 
    userTypeRole();
  };

  useEffect(() => {
    if (tenantID) {
      userTypeRole();
    }
  }, [tenantID]);
  useEffect(()=>{
    
    if(userTblData?.data){
      setTableData(userTblData?.data?.appUserLists);
    }
  },[userTblData]);

  useEffect(() => {
    if (userTblData1?.data) {
      setSearchData(userTblData1?.data.appUserLists);
    }
  }, [userTblData1]);

  useEffect(() => {
    if (tenantID) {
      if (subsProductInfo?.data) {
        setProductsInfo(subsProductInfo?.data);
      }
    }
  }, [subsProductInfo, tenantID]);

  const onClose = () => {
    setOpen(false);
    form.resetFields();
  };

  function userGrid(search, page, pageSize, sortField, sortOrder, status) {
    let inputJson = {
      "AppUserParams": {
        "TenantId": tenantID,
        "ProductID": productID,
        "Status": status
      },
      "ServerSearchables": {
        "draw": page,
        "searchData": search,
        "orderByColumn": sortField,
        "orderBy": sortOrder,
        "currentPage": page,
        "pageSize": pageSize,
        "pageNumber": page
      },
      "VwEntAppUser": []
    }
    dispatch(userActGrid(inputJson));
    setTableData([]);
  }

  useEffect(() => {
    if (tenantID) {
      userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, userStatus);
    }
  }, [dispatch, tenantID]);

  function searchUserData(search) {
    let inputJson = {
      "AppUserParams": {
        "TenantId": tenantID,
        "ProductID": productID,
        "Status": "Active"
      },
      "ServerSearchables": {
        "draw": 1,
        "searchData": search,
        "orderByColumn": "AppUserID",
        "orderBy": "Desc",
        "currentPage": 1,
        "pageSize": 1000,
        "pageNumber": 1
      },
      "VwEntAppUser": []
    }
    dispatch(searchUserActGrid(inputJson));
  }

  const typeRoleData = typeRoleDpd?.data?.map((item) => {
    return (
      {
        label: item.userType,
        value: item.userTypeID,
        key: item.i
      }
    )
  });

  const columns1 = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Login ID',
      dataIndex: 'appUserName',
      key: 'appUserName',
    },
    {
      title: 'User Type',
      dataIndex: 'userType',
      key: 'userType',
    },
    {
      title: 'Last Login',
      dataIndex: 'lastlogin',
      key: 'lastlogin',
    },
    {
      title: 'Status',
      dataIndex: 'appUserStatus',
      key: 'appUserStatus',
      render: (appUserStatus, record) => {
        return (
          <div onClick={(event) => {
            event.stopPropagation(); 
            // setOpenStatus(true); 
            setRowData(record);
            setGroupStatus(record.appUserStatus == "Active" ? true : false)
          }}>
            {/* <Switch defaultChecked={appUserStatus == 'Active' ? true : false} 
                checkedChildren="Active"  
              unCheckedChildren="InActive"
              /> */}
              <Popconfirm
            placement="topLeft"
            title="Are you sure you want to change the user status"
            onConfirm={() => updateStatus(appUserStatus)}
            okText="Yes"
            cancelText="No"
          >
              <Button className={`status-btn  ${appUserStatus === 'InActive' ? 'selected' : ''}`}>{appUserStatus}</Button>
          </Popconfirm>
              
              </div>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',

      render: (id, record) => {
        return (
          <div onClick={(event) => {
            // event.stopPropagation();
          }}>
            <Tooltip title="Edit User" className='mt-0'>
              <EditFilled className='me-2 edit-icon text-success' onClick={(event) => {editUser(record, false);event.stopPropagation();}} />
            </Tooltip>
            <Tooltip title="Change Password" className='mt-0'>
              <LockOutlined className="me-2 text-primary" onClick={(event) =>{ handleOpenPass(record); event.stopPropagation();}} />
            </Tooltip>
            <Tooltip title="View User Details" className='mt-0'>
              <EyeOutlined className="text-primary" onClick={() =>{setShowDetail(true); setRowData(record);}} />
            </Tooltip>
          </div>
        );
      }
    },
  ];
  function getAssociatedProducts(id) {
    dispatch(assocOtherProducts(id));
  }

  const editUser = (item, isFlag) => {
    setAssProductFlag(isFlag);
    setAppUserId(item.appUserId);
    showDrawer();
    let d = [];
    let typeList = typeRoleDpd?.data || [];
    for (let i = 0; i < typeList.length; i++) {
      if (typeList[i].userTypeID == item.userTypeID) {
        for (let j = 0; j < typeList[i].roles.length; j++) {
          d.push({
            label: typeList[i].roles[j].roleName,
            value: typeList[i].roles[j].roleId,
            key: typeList[i].roles[j].roleId
          })
        }
      }
    }
    setCheckedVal("2");
    setRoleOptions(d);
    form.setFieldsValue({
      firstName: item.firstName,
      lastName: item.lastName,
      userName: item.appUserName,
      userType: item.userTypeID,
      userRole: item.roleId
    });
    let ids = `${tenantID}`;
    dispatch(subscribedProduct(ids));
    if (isFlag == true) {

    }
    getAssociatedProducts(item.appUserId);
  }
  const handleChangeCAR = (e) => {
    setCheckedVal(e.target.value);
  }

  function userTypeRole() {
    let id = `${productID}/${tenantID}`;
    dispatch(userTypeRoleDpdn(id));
  }

  const handleTypeChange = (val) => {
    let d = [];
    let typeList = typeRoleDpd.data;
    for (let i = 0; i < typeList.length; i++) {
      if (typeList[i].userTypeID == val) {
        for (let j = 0; j < typeList[i].roles.length; j++) {
          d.push({
            label: typeList[i].roles[j].roleName,
            value: typeList[i].roles[j].roleId,
            key: typeList[i].roles[j].roleId
          })
        }
      }
    }
    setRoleOptions(d);
  }

  const submitForm = (values) => {
    let inputJson = [{
      "AppUserID": appUserId,
      "UserName": values.userName,
      "Password": "pass",
      "TenantID": tenantID,
      "FirstName": values.firstName,
      "MiddleName": null,
      "LastName": values.lastName,
      "CreatedBy": 26,
      "RoleID": values.userRole,
      "UserTypeID": values.userType,
      "ProductID": productID,
      "DefaultUserGroupID": 0
    }]
    dispatch(addUser(inputJson));
    if(appUserId === 0){
      setShowsuccessmsg(true);
    }
    else{
      setShowsuccessmsg3(true);
    }
    onClose();
  }

  useEffect(() => {
    if (successmsg) {
      message.success("User Account Added Successfully");
      userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, userStatus);
      setShowsuccessmsg(false);
    }
    if (successmsg3) {
      message.success("User Account Updated Successfully");
      userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, userStatus);
      setShowsuccessmsg3(false);
    }
  }, [successmsg,successmsg3]);

  useEffect(() => {
    if (successmsg1) {
      message.success("Status Updated Successfully");
      userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, userStatus);
      setShowsuccessmsg1(false);
    }
  }, [successmsg1]);

  useEffect(() => {
    if (successmsg2) {
      message.success("Password Updated Successfully");
      userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, userStatus);
      setShowsuccessmsg2(false);
    }
  }, [successmsg2]);
  const callbackFunction = (item) => {
    setShowDetail(item);
  }
  const closeOpenStatus = () => {
    setOpenStatus(false);
  }
  const updateStatus = (status) => {
    let inputJson = {
      "AppUserID": rowData?.appUserId,
      "Status": status == "Active"? "InActive" : "Active"
    }
    dispatch(changeUserStatus(inputJson));
    setShowsuccessmsg1(true);
    closeOpenStatus();
  }
// "Status": groupStatus == true ? "Active" : "InActive"
  const onChangeStatus = (checked) => {
    setGroupStatus(checked);
  }
  const handleChangeStatus = (e) => {
    setUserStatus(e.target.value);
    userGrid(searchTableVal, pageIndex, pageSize, sortField, sortOrder, e.target.value);
  }
  const handleTableChange = (pagination, ...sorted) => {
    let sort = "";
    if (sorted[1].order === "ascend") {
      sort = "asc";
    } else sort = "desc";
    setPageIndex(pagination.current);
    setSortField(sorted[1].field);
    setSortOrder(sort);
    userGrid(searchTableVal, pagination.current, pagination.pageSize, sorted[1].field, sort, userStatus);
  }

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearchTableVal(e.target.value);
      setPageIndex(1);
      userGrid(e.target.value, 1, pageSize, sortField, sortOrder, userStatus);
    }
  }
  const resetSearch = (e) => {
    if (e.key === "Backspace" && !e.target.value) {
      setSearchTableVal("");
      setPageIndex(1);
      userGrid(e.target.value, 1, pageSize, sortField, sortOrder, userStatus);
    }
  }

  const handleCancelPass = () => {
    setOpenPass(false);
  }

  const handleOpenPass = (val) => {
    setRowData(val);
    setOpenPass(true);
  }
  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('The two passwords that you entered do not match!'));
    },
  });

  const handleSubmitPass = async (values) => {
    let inputJson = {
      "AppUserID": rowData?.appUserId,
      "TenantID": tenantID,
      "ProductID": productID,
      "Password": values.password
    }
    dispatch(changePass(inputJson));
    setShowsuccessmsg2(true);
    handleCancelPass();
  }
  const handleSearchUser = (e) => {
    searchUserData(e.target.value);
  }

  const handleCheckProdu =e=> (val) => {
    let inputJson = {
      "ProductID": val.productID,
      "TenantID": val.tenantID
    }
    // dispatch(getUserType(inputJson));
  }

  return (
    <>
      <div className="mt-2 ">
        {showDetail ?
          <UserDetail data={{ rowData: rowData, callbackFunction: callbackFunction }} /> :
          <Card className="border-0" >
            <div className='row ps-4 pe-3 mb-2'>
              <div className='col text-start ms-1 my-auto'>
                <h6 className="my-auto">List of Users</h6>
              </div>
              <div className='col-auto ms-auto text-start ms-1 pe-0' >
                <Radio.Group buttonStyle="solid" className='pe-2 user-status' defaultValue={userStatus} onChange={handleChangeStatus}>
                  <Radio.Button  className={`active ${userStatus === 'Active' ? 'selected' : ''}`} value="Active">Active</Radio.Button>
                  <Radio.Button  className={`inactive px-2 ${userStatus === 'InActive' ? 'selected' : ''}`} value="InActive">InActive</Radio.Button>
                </Radio.Group>
              </div>
              <div className='col-3 ps-0'>
                <div className='row right-side pe-0'>
                  <div className='col-md pe-0'>
                    <Input size='default' placeholder='search' onKeyDown={(e) => handleSearch(e)}
                      onKeyUp={(e) => resetSearch(e)} prefix={<SearchOutlined />} ></Input>
                  </div>
                  <div className='col-md-auto ps-2 pe-3'>
                  <Tooltip title="Add New User" className='mt-0'>
                    <Button size='default' className="add-btn pe-2 border-0" icon={<UserAddOutlined />} onClick={() => { showDrawer(); setAppUserId(0); form.resetFields() }}>  </Button>
                  </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <Table className="entitlement-table" rowKey="appUserId" loading={loading}
                columns={columns1} dataSource={tableData} onChange={handleTableChange}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: event => {
                      setShowDetail(true);
                      setRowData(record);
                    },
                  };
                }}
                pagination={{
                  current: pageIndex,
                  pageSize: pageSize,
                  total: totalPage,
                  onChange: (page, pageSize) => {
                    setPageIndex(page);
                    setPageSize(pageSize);
                    userGrid(searchTableVal, page, pageSize, sortField, sortOrder, userStatus)
                  }
                }}
              /></div>
          </Card>
        }

        <Drawer
          title="Add/Update User Account"
          width={560}
          onClose={onClose}
          open={open}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose={true}
        >
          <Form
            form={form}
            layout="vertical"
            name="basic"
            onFinish={submitForm} >
            <div className=' row mt-2 ref-container'>
              <Radio.Group onChange={handleChangeCAR} value={checkedVal}>
                <div className='row bg-light p-2 '>
                  <div className='col-auto ps-1'>
                    <Radio value="1">Using Employee Record</Radio>
                  </div>
                  <div className='col-auto'>
                    <div className='row'>
                      <Radio value="2">Manual Entry</Radio>
                    </div>
                  </div>
                </div>
              </Radio.Group>

              {checkedVal == "1" ? <>
                <div className="mt-3">
                  <Form.Item label="Search by First or Last Name or Employee Number" name='search' className='col-md-6 w-100'>
                    <Input onChange={handleSearchUser} />
                  </Form.Item>
                </div>
                {searchData.length > 0 ?
                  <div className="bg-light p-2">
                    <div className="mb-2">User List</div>
                    {searchData.map((item) => {
                      return <div className="card p-2 mb-2" key={item.appUserId} onClick={() => editUser(item, true)}>
                        <div className=" m-0">
                          <div><span className="me-1">Full Name:</span><span>{item.fullName}</span></div>
                          <div><span className="me-1">User Name:</span><span>{item.appUserName}</span></div>
                        </div>
                      </div>
                    })}
                  </div> : ""}
              </> : ""}

              {checkedVal == "2" ? <>

                <Card className='mt-4 me-2 '>

                  <div className='row mt-4 ms-1'>
                    <Form.Item label="First Name" name='firstName' className='col-md-6'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required!',
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                    <Form.Item label="Last Name" name='lastName' className='col-md-6' rules={[
                      {
                        required: true,
                        message: 'This field is required!',
                      }
                    ]}>
                      <Input />
                    </Form.Item>
                  </div>
                  <div className='row ms-1'>
                    <Form.Item label="User Name" name='userName' className='col-md-6' rules={[
                      {
                        required: true,
                        message: 'This field is required!',
                      }, {
                        type: "email",
                        message: "Enter valid mail Id"
                      }
                    ]}>
                      <Input />
                    </Form.Item>
                    <Form.Item label="User Type" name='userType' className='col-md-6' rules={[
                      {
                        required: true,
                        message: 'This field is required!',
                      }
                    ]}>
                      <Select options={typeRoleData} onChange={handleTypeChange} />
                    </Form.Item>
                  </div>
                  <div className='row ms-1'>
                    <Form.Item label="User Roles" name='userRole' className='col-md-6'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required!',
                        }
                      ]}>
                      <Select options={roleOptions} />
                    </Form.Item>
                    <Checkbox className='col my-auto '>Notify User?</Checkbox>
                  </div>
                </Card>
                {/* {productsInfo?.length > 0}{

                  <div className="my-2 px-0">
                    {productsInfo.length>0?<span className="mb-2">Enable Access to Following Associated Product(s)</span>:""}
                    {productsInfo?.map((item) => {
                      return <div className="bg-light mb-2 p-3" key={item.productID}>
                        <Checkbox onChange={()=>handleCheckProdu(item)} className="mb-2">{item.prodName}</Checkbox>
                        <div className="row m-0">
                          <div className="col-md-6">
                            <Form.Item label="User Type" name='assUserType'
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required!',
                                }
                              ]}>
                              <Select className="w-100"/>
                            </Form.Item>
                          </div>
                          <div className="col-md-6">
                            <Form.Item label="User Roles" name='assUserRole'
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required!',
                                }
                              ]}>
                              <Select className="w-100"/>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    })}

                  </div>
                } */}
                <div className=" my-3 row ms-auto ">
                  <Button type="primary ms-auto cancel-btn" className="me-2 col-auto ms-auto dlv-cancel-btn" danger onClick={onClose}>Cancel</Button>
                  <Button type="primary" htmlType="submit" className="me-0 col-auto dlv-save-btn">Save</Button>
                </div>
              </> : ""}
            </div>
          </Form>
        </Drawer>
        {/* enable /disable user */}
        <Drawer
          title="Enable/Disable User Group"
          width={550}
          onClose={closeOpenStatus}
          open={openStatus}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose={true}
        >
          <div className="bg-blue p-3 mb-3">
            <div><span className="fw-bold">First Name:</span> <span>{rowData?.firstName}</span></div>
            <div><span className="fw-bold">User Name:</span> <span>{rowData?.appUserName}</span></div>
            <div className="d-flex w-75">
              <div><span className="fw-bold">User Type:</span> <span>{rowData?.userType}</span></div>
              <div><span className="fw-bold ms-auto">User Role:</span> <span>{rowData?.roleName}</span></div>
            </div>
          </div>
          <Switch defaultChecked={groupStatus}
            onChange={onChangeStatus}
          />
          <div className="mt-4 text-end">
            <Button type="default" onClick={closeOpenStatus} className="me-2 col-auto ms-auto" danger>Cancel</Button>
            <Button type="primary" onClick={updateStatus} className="me-0 col-auto">Update</Button>
          </div>
        </Drawer>
        {/* change user password */}
        <Drawer
          title="Change Password"
          width={550}
          onClose={handleCancelPass}
          open={openPass}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose={true}
        >
          <div className="bg-blue p-3 mb-3">
            <div><span className="card-titles">First Name:</span> <span>{rowData?.firstName}</span></div>
            <div className="my-1"><span className="card-titles">User Name:</span> <span>{rowData?.appUserName}</span></div>
            <div className="d-flex w-100">
              <div><span className="card-titles">User Type:</span> <span>{rowData?.userType}</span></div>
              <div className="ms-3"><span className="card-titles">User Role:</span> <span>{rowData?.roleName}</span></div>
            </div>
          </div>
          <Form
            autoComplete='off'
            form={form1}
            onFinish={handleSubmitPass}
            // onFinish={handleSubmitPass}
            // initialValues={initialValues}
            layout="vertical">
            <div className=' text-start'>
              <div className="  ">
                <Form.Item key={Math.random()} label="Password" name='password' className='w-100' rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },
                  {
                    pattern: passwordPattern,
                    message: 'Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one number, and one special character'
                  }

                ]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
              </div>
              <div className=" ">
                <Form.Item
                  validateTrigger="onChange"
                  label="Confirm Password" name='confirmpassword' className='w-100' rules={[
                    {
                      required: true,
                      message: 'Confirm password is required',
                    },
                    validateConfirmPassword,
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </div>
            </div>
            <div className="mt-4 text-end">
              <Button type="primary ms-auto cancel-btn" onClick={handleCancelPass} className="me-2 col-auto ms-auto dlv-cancel-btn" danger>Cancel</Button>
              <Button type="primary" htmlType="submit" className="me-0 col-auto dlv-save-btn">Update</Button>
            </div>
          </Form>
        </Drawer>
      </div>
    </>
  )
}


